// ** React Imports
import React, { Fragment, ReactNode, useEffect } from 'react'

// ** Modules Imports
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { useStore } from 'effector-react'
import { useFlag } from '@unleash/proxy-client-react'

// ** Source code Imports
import { useSettings } from 'src/@core/hooks'
import landingStore, { getLandingDetail, getTableForLanding } from 'src/state-manager/landing'
import Spinner from 'src/@core/components/spinner'
import DefaultLayout from 'src/layouts/default-layout'
import newsStore, { getNewsList } from 'src/state-manager/news'

const NewsPage = dynamic(() => import('src/views/pages/news-page'), {
  ssr: false
})

const News = () => {
  const settings = useSettings()
  const { replace } = useRouter()

  const { landingDetails } = useStore(landingStore.landing)
  const { data: newsData } = useStore(newsStore.news)

  const isLandingNewsAvailable = useFlag('is_landing_news_available')

  useEffect(() => {
    getNewsList({
      query: { ['data.showToLanding']: true }
    })

    getTableForLanding({
      key: 'platforms',
      tableName: 'landing_platforms'
    })

    getLandingDetail()
  }, [])

  const isLoading = landingDetails.loading

  if (!isLandingNewsAvailable) {
    replace('/404')
  }

  return (
    <Fragment>
      {isLoading && <Spinner settings={settings}/>}
      <DefaultLayout sx={{
        height: isLoading ? 0 : 'auto',
        visibility: isLoading ? 'hidden' : 'visible'
      }}>
        <NewsPage
          landingDetails={landingDetails.data}
          newsItems={newsData}
        />
      </DefaultLayout>
    </Fragment>
  );
}

News.getLayout = (page: ReactNode) => page

export default News
